import { createContext } from 'react';
import { messages as enMessages } from '../lang/en';
import { messages as faMessages } from '../lang/fa';
import { getSettingItem } from '../utils/storage';

const lang = getSettingItem('lang');

const MessagesContext = createContext({
    messages: lang === 'en' ? enMessages : faMessages,
    setMessages: (messages) => messages
});
export default MessagesContext;
